import React, { useEffect } from 'react';

import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';

import Style from '../Header.module.css';

import { getSavedJobs, myApplications } from '../../../../redux/actions/aeJobs';

import { Loader } from '../../../atoms';

import { pushEventInLoggy } from '../../../../utils/loggy';

function OptionsUnderJobs({ isMobile }) {
  const { my_profile, applied_jobs_list, saved_jobs_list } = useSelector((state) => state);
  const router = useRouter();
  const dispatch = useDispatch();
  const pathVal = router?.pathname;

  useEffect(() => {
    if (my_profile?.data) {
      dispatch(myApplications({ limit: 10, offset: 0 }))
        .then(() => {})
        .catch(() => {});
      dispatch(getSavedJobs({ limit: 10, offset: 0 }))
        .then(() => {})
        .catch(() => {});
    }
  }, []);

  const handleEventTrigger = (event_name) => {
    pushEventInLoggy(
      {
        event: event_name,
        page_name: 'Candidate Dashboard'
      },
      my_profile
    );
  };

  return (
    <>
      {!isMobile ? (
        <div className='container'>
          <div className=''>
            <div className={`${Style.flexStyleStart} ${Style.bottomBorder}`}>
              <a href='/jobs/explore'>
                <div className={pathVal === '/jobs/explore' ? Style.jobOptSelected : Style.jobOptNotSelected}>Explore Jobs</div>
              </a>
              {my_profile?.data ? (
                <>
                  <a href='/jobs/applied-jobs' onClick={() => handleEventTrigger('Applied_Jobs')}>
                    <div className={pathVal === '/jobs/applied-jobs' ? Style.jobOptSelected : Style.jobOptNotSelected}>
                      {applied_jobs_list?.isFetching ? (
                        <Loader size='sm' type='text-light' />
                      ) : applied_jobs_list?.isFetching === null ? (
                        <Loader size='sm' type='text-light' />
                      ) : applied_jobs_list?.data?.data?.total ? (
                        `Applied Jobs ( ${applied_jobs_list?.data?.data?.total} )`
                      ) : (
                        `Applied Jobs ( 0 )`
                      )}
                    </div>
                  </a>
                  <a href='/jobs/saved-jobs' onClick={() => handleEventTrigger('Saved_Jobs')}>
                    <div className={pathVal === '/jobs/saved-jobs' ? Style.jobOptSelected : Style.jobOptNotSelected}>
                      {/* Saved Jobs ({saved_jobs_list?.data?.data?.total ? saved_jobs_list?.data?.data?.total : 0}) */}
                      {saved_jobs_list?.isFetching ? (
                        <Loader size='sm' type='text-light' />
                      ) : saved_jobs_list?.isFetching === null ? (
                        <Loader size='sm' type='text-light' />
                      ) : saved_jobs_list?.data?.data?.total ? (
                        `Saved Jobs ( ${saved_jobs_list?.data?.data?.total} )`
                      ) : (
                        `Saved Jobs ( 0 )`
                      )}
                    </div>
                  </a>
                </>
              ) : null}
            </div>
          </div>
        </div>
      ) : (
        <div className={`${Style.flexStyleStart} ${Style.bottomBorder} x-scrollable`}>
          <a href='/jobs/explore'>
            <div className={pathVal === '/jobs/explore' ? Style.jobOptSelected : Style.jobOptNotSelected}>Explore Jobs</div>
          </a>
          {my_profile?.data ? (
            <>
              <a href='/jobs/applied-jobs' onClick={() => handleEventTrigger('Applied_Jobs')}>
                <div className={pathVal === '/jobs/applied-jobs' ? Style.jobOptSelected : Style.jobOptNotSelected}>
                  {/* Applied Jobs ({applied_jobs_list?.data?.data?.total ? applied_jobs_list?.data?.data?.total : 0}) */}
                  {applied_jobs_list?.isFetching ? (
                    <Loader size='sm' type='text-light' />
                  ) : applied_jobs_list?.isFetching === null ? (
                    <Loader size='sm' type='text-light' />
                  ) : applied_jobs_list?.data?.data?.total ? (
                    `Applied Jobs ( ${applied_jobs_list?.data?.data?.total} )`
                  ) : (
                    `Applied Jobs ( 0 )`
                  )}
                </div>
              </a>
              <a href='/jobs/saved-jobs' onClick={() => handleEventTrigger('Saved_Jobs')}>
                <div className={pathVal === '/jobs/saved-jobs' ? Style.jobOptSelected : Style.jobOptNotSelected}>
                  {/* Saved Jobs ({saved_jobs_list?.data?.data?.total ? saved_jobs_list?.data?.data?.total : 0}) */}
                  {saved_jobs_list?.isFetching ? (
                    <Loader size='sm' type='text-light' />
                  ) : saved_jobs_list?.isFetching === null ? (
                    <Loader size='sm' type='text-light' />
                  ) : saved_jobs_list?.data?.data?.total ? (
                    `Saved Jobs ( ${saved_jobs_list?.data?.data?.total} )`
                  ) : (
                    `Saved Jobs ( 0 )`
                  )}
                </div>
              </a>
            </>
          ) : null}
        </div>
      )}
    </>
  );
}

export default OptionsUnderJobs;
